/** 年商 */
export const enum AnnualSalesType {
  /** 0: 1000万円以下 */
  _0_under10m,
  /** 1: 5000万円以下 */
  _1_under500m,
  /** 2: 1億円以下 */
  _2_under1000m,
  /** 3: 5億円以下 */
  _3_under5000m,
  /** 4: 10億円以下 */
  _4_under1b,
  /** 5: 50億円以下 */
  _5_under5b,
  /** 6: 100億円以下 */
  _6_under10b,
  /** 7: 100億円超 */
  _7_over10b,
}

export function getAnnualSalesTypeName(value: number | "") {
  if (value === "") {
    return "";
  }
  switch (value) {
    case AnnualSalesType._0_under10m:
      return "1000万円以下";
    case AnnualSalesType._1_under500m:
      return "5000万円以下";
    case AnnualSalesType._2_under1000m:
      return "1億円以下";
    case AnnualSalesType._3_under5000m:
      return "5億円以下";
    case AnnualSalesType._4_under1b:
      return "10億円以下";
    case AnnualSalesType._5_under5b:
      return "50億円以下";
    case AnnualSalesType._6_under10b:
      return "100億円以下";
    case AnnualSalesType._7_over10b:
      return "100億円超";

    default:
      return "";
  }
}
